// Powered-by-Oriora badge — the credit line under any AI output.
// Cloned verbatim from the canonical source:
//   web/landing/app/components/OrioraBadge.tsx
// Plain React + inline styles + zero deps. Render it under every AI result:
//   <OrioraBadge />
// Brand-only by decision (Bogdan, 2026-06-30): shows EXACTLY "Routed by Oriora"
// — no model name, no price, no reassurance text. Don't add data props.

export function OrioraBadge({
  hidden,
}: {
  hidden?: boolean; // account-level toggle: pass true to suppress
}) {
  if (hidden) return null;
  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 6,
        fontSize: 11,
        lineHeight: 1.4,
        color: "var(--text-tertiary, #71717a)",
        fontFamily:
          'ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
      }}
    >
      <span>
        Routed by <span style={{ color: "var(--accent, #a78bfa)", fontWeight: 600 }}>Oriora</span>
      </span>
    </div>
  );
}

export default OrioraBadge;
